import {
  AdAccountPlatform,
  AdAccountPlatformLabels,
  AdAccountResource,
  AdAccountTypes,
} from "@arrowsup/platform-dtos";
import { connectedAccountTypeChoices } from "../connected-accounts/connected-account-fields";

export const adAccountPlatformChoices =
  connectedAccountTypeChoices(AdAccountTypes);

export const platformLabel = (platform?: AdAccountPlatform | null) =>
  platform ? AdAccountPlatformLabels[platform] : "—";

/** "Acme (Google Ads 1234567890)". */
export const adAccountLabel = (
  account?: Pick<AdAccountResource, "name" | "platform" | "externalId"> | null
) =>
  account
    ? `${account.name ?? "Unnamed"} (${platformLabel(account.platform)} ${
        account.externalId
      })`
    : "—";

/** Default first day for new ad data streams, matching what Airbyte pulled. */
export const defaultAdDataStartDate = "2025-01-01";
